export const USER = 'USER';
export const ADMIN = 'ADMIN';
export const SUPER_ADMIN = 'SUPER_ADMIN';

export const AVAILABLE_AUTH_ROLES = [
    USER,
    ADMIN,
    SUPER_ADMIN
];

export const DEFAULT_AUTH_ROLE = USER;